<template>
  <section class="cart-table">
    <div class="cart-table-wrap content">
      <ul>
        <li class="header ou-flex-center">
          <div class="goods-info">
            <div class="goods-cover"></div>
            <div class="goods-name">商品信息</div>
          </div>
          <div class="goods-price ou-expand">售价</div>
          <div v-show="type === 'cart'" class="goods-action ou-expand">
            操作
          </div>
          <div v-show="type === 'preOrder'" class="goods-price-real">
            实付款
          </div>
        </li>
        <div>
          <cart-item
            v-for="(item, index) in goodsList"
            :key="index"
            :itemData="item"
            :itemIndex="index"
            :type="type"
          ></cart-item>
        </div>
        <div v-if="noData">
          <no-data />
        </div>

        <li v-show="type === 'preOrder'" class="bottom-bar order">
          <div>
            <div class="bottom-row">
              <span class="prices"
                >商品总价:
                <span class="price-span origin">{{
                  goodsTotal | paymentText
                }}</span></span
              >
              <span
                >实付:
                <span class="price-span real">{{
                  totalPrice | paymentText
                }}</span></span
              >
            </div>
            <div class="inline-box">
              <div class="goods-total ou-expand">
                <el-button
                  v-if="status === '0'"
                  type="text"
                  @click="$emit('handleCancel')"
                  class="cancel-btn"
                  >取消订单</el-button
                >
              </div>
              <div class="goods-action ou-expand">
                <el-button
                  v-if="status === '0'"
                  @click="$emit('handlePay')"
                  class="order-btn"
                  >去付款</el-button
                >
                <el-button
                  v-if="status === '2'"
                  @click="goBookStore"
                  class="order-btn"
                  >去下单</el-button
                >
                <el-button
                  v-if="status === '1'"
                  @click="goEvaluate"
                  class="order-btn"
                  >去评价</el-button
                >
              </div>
            </div>
            <div class="ou-text-tips">温馨提示：此类商品不支持退换货</div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiCreateOrder } from "@/api/user/order";
import { apiBatDeleteCartItems } from "@/api/cart/cart";
import NoData from "@/components/noData.vue";
import CartItem from "../CartItem";
export default {
  name: "CartTable",
  components: { CartItem, NoData },
  props: {
    type: { type: String, default: "preOrder" },
    status: { type: String, default: "" },
    totalPrice: { type: Number, default: 0 },
    goodsList: { type: Array, default: () => [] },
    orderNumber: { type: String, default: "" },
  },
  data() {
    return {
      delConfirmVisible: false,
    };
  },

  watch: {},
  computed: {
    ...mapGetters([
      "getCartNum",
      "getCheckNum",
      "getTotalPrice",
      "getIsAllCheck",
      "getCheckGoods",
      "userId",
    ]),
    isAllCheck: {
      get() {
        return !!this.getCartNum && this.getIsAllCheck;
      },
      set(val) {
        this.checkAll(val);
      },
    },
    noData() {
      return !this.goodsList.length;
    },
    goodsTotal() {
      let total = 0;
      this.goodsList.forEach((item) => {
        total += Number(item.payMoney) || 0;
      });
      return total;
    },
    isIndeterminate() {
      return this.getCheckNum !== 0 && !this.getIsAllCheck;
    },
  },
  filters: {
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    goBookStore() {
      if (this.goodsList[0].sourceType == "subject") {
        this.$router.push("/special/index");
      } else {
        this.$router.push("/bookstore/index");
      }
    },
    goEvaluate() {
      this.$router.push({
        path: "/user/orderDetail/orderAppraise",
        query: { orderNumber: this.orderNumber },
      });
    },
    deleteSelectedItems() {
      let goods = this.getCheckGoods;
      if (!goods.length) {
        this.$message.error("尚未选择任何商品");
        return;
      }
      this.$confirm(
        `确定要移除已勾选的${this.getCheckNum}件商品吗？`,
        "系统提示",
        {
          type: "warning",
        }
      ).then(() => {
        let list = [];
        goods.forEach((item) => list.push(item.id));
        apiBatDeleteCartItems({ ids: list.join(",") }).then((res) => {
          console.log("批量移除购物车商品返回", res);
          this.$store.dispatch("GetShoppingCart").then(() => {
            this.$message.success("移除成功");
          });
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* 购物车主要内容区CSS */
.cart-table-wrap.content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  height: auto;
  background-color: #fffefd;
  ul ::v-deep {
    background-color: #fffefd;
    color: #424242;
    line-height: 52px;
    .header {
      height: 48px;
      padding: 0 20px;
      color: #333333;
      font-size: 14px;
      border-bottom: 1px solid #f2f2f2;
      .goods-info {
        .goods-name {
          padding-left: 98px;
        }
      }
    }
    .goods-item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;
      padding: 0 20px;
      height: 130px;
      .goods-info {
        display: flex;
        .goods-cover {
          cursor: pointer;
          height: 90px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin: 0 auto;
          }
          .el-image__error {
            width: 90px;
            height: 90px;
            text-align: center;
            line-height: 90px;
            border-radius: 8px;
          }
        }
        .goods-name {
          flex: 1;
          font-size: 14px;
          line-height: 32px;
          span {
            cursor: pointer;
            &:hover {
              color: #2e9adb;
            }
          }
        }
        .goods-price.real {
          width: 252px;
        }
      }
    }
    .bottom-bar {
      display: flex;
      align-items: center;
      padding: 0 20px;
      border-bottom: 1px solid #f2f2f2;
      font-size: 14px;
      &.order {
        height: 135px;
        padding: 0 40px;
        justify-content: flex-end;
        .bottom-row {
          line-height: 32px;
        }
        .prices {
          margin-right: 40px;
          color: #333333;
        }
        .inline-box {
          text-align: right;
          line-height: 40px;
          & > div {
            display: inline-block;
          }
          .goods-total {
            font-size: 14px;
            margin-right: 20px;
            .price-span {
              margin-left: 12px;
            }
          }
          .cancel-btn {
            color: #999999;
          }
          .order-btn {
            height: 40px;
          }
        }
        .ou-text-tips {
          line-height: 32px;
          text-align: right;
        }
      }
    }
    .goods-check {
      width: 80px;
    }
    .goods-info {
      width: 50%;
      min-width: 480px;
      div {
        display: inline-block;
      }
      .goods-cover {
        width: 130px;
        img {
          width: 90px;
          height: 90px;
        }
      }
    }
    .goods-price-real {
      text-align: center;
      width: 252px;
    }
    .goods-bat-del {
      width: 52%;
      padding-left: 18px;
    }
    .goods-price,
    .goods-num,
    .goods-total {
      text-align: center;
    }
    .goods-action {
      text-align: center;
      .order-btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        color: #ffffff;
        padding: 0;
        background: #2e9adb;
        border-radius: 6px;
      }
    }
    .price-span {
      font-size: 14px;
      font-weight: 400;
      color: #ff5353;
      &::before {
        content: "¥";
      }
      &.normal {
        color: #666666;
      }
      &.real {
        font-size: 18px;
      }
    }
  }
}
</style>
